import React, { useState } from "react";
import { useNotification } from "../hooks/useNotification"; // <-- IMPORTAÇÃO
import "./CadastroProfessor.css";

const CadastroProfessor = () => {
  const [nome, setNome] = useState("");
  const [numeroBI, setNumeroBI] = useState("");
  const [dataNascimento, setDataNascimento] = useState("");
  const [nivelAcademico, setNivelAcademico] = useState("");
  const [experiencia, setExperiencia] = useState("");
  const [genero, setGenero] = useState("");
  const [telefone, setTelefone] = useState("");
  const [email, setEmail] = useState("");
  const [disciplinas, setDisciplinas] = useState([]);
  const [classes, setClasses] = useState([]);

  const { notifySuccess, notifyError } = useNotification(); // <-- USO DO HOOK

  const niveisAcademicos = ["Docente N1", "Licenciatura", "Mestrado", "Doutoramento", "PhD"];
  const opcoesGenero = ["Masculino", "Feminino", "Outro"];
  const opcoesDisciplinas = [
    "Matemática", "Português", "Física", "Química", "Ed.Visual", "Ed.Física",
    "Biologia", "Agro-pecuária", "História", "Geografia", "Filosofia", "Frances", "Inglês"
  ];
  const opcoesClasses = [
    "1ª Classe", "2ª Classe", "3ª Classe", "4ª Classe",
    "5ª Classe", "6ª Classe", "7ª Classe", "8ª Classe",
    "9ª Classe", "10ª Classe", "11ª Classe", "12ª Classe"
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();

    const telefoneRegex = /^[0-9]{9,15}$/;
    if (!telefoneRegex.test(telefone)) {
      notifyError("O número de telefone está em um formato inválido.");
      return;
    }

    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    if (!emailRegex.test(email)) {
      notifyError("O e-mail fornecido é inválido.");
      return;
    }

    const biRegex = /^\d{12}[A-Z]$/;
    if (!biRegex.test(numeroBI)) {
      notifyError("O número de BI deve conter 12 dígitos seguidos de 1 letra maiúscula (ex: 123456789012A).");
      return;
    }

    const professorData = {
      nome,
      numeroBI,
      dataNascimento,
      nivelAcademico,
      experiencia,
      genero,
      telefone,
      email,
      disciplinas,
      classes,
    };

    try {
      const response = await fetch("/api/professores/cadastrar", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(professorData),
      });

      if (response.ok) {
        notifySuccess("Professor cadastrado com sucesso!");
        handleReset();
      } else {
        const errorData = await response.json();
        const mensagensErro = errorData.erros || [errorData.erro] || ["Erro desconhecido"];
        notifyError(`Erro ao cadastrar professor: ${mensagensErro.join(", ")}`);
      }
    } catch (error) {
      console.error("Erro ao cadastrar:", error);
      notifyError("Erro na conexão com o servidor.");
    }
  };

  const handleReset = () => {
    setNome("");
    setNumeroBI("");
    setDataNascimento("");
    setNivelAcademico("");
    setExperiencia("");
    setGenero("");
    setTelefone("");
    setEmail("");
    setDisciplinas([]);
    setClasses([]);
  };

  return (
    <div className="cadastro-professor-container">
      <h2>Cadastro de Professor(a)</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Nome Completo:</label>
          <input value={nome} onChange={(e) => setNome(e.target.value)} required />
        </div>

        <div className="form-group">
          <label>Número de BI:</label>
          <input value={numeroBI} onChange={(e) => setNumeroBI(e.target.value)} required />
        </div>

        <div className="form-group">
          <label>Data de Nascimento:</label>
          <input type="date" value={dataNascimento} onChange={(e) => setDataNascimento(e.target.value)} required />
        </div>

        <div className="form-group">
          <label>Nível Acadêmico:</label>
          <select value={nivelAcademico} onChange={(e) => setNivelAcademico(e.target.value)} required>
            <option value="">Selecione...</option>
            {niveisAcademicos.map((nivel, index) => (
              <option key={index} value={nivel}>{nivel}</option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label>Gênero:</label>
          <select value={genero} onChange={(e) => setGenero(e.target.value)} required>
            <option value="">Selecione...</option>
            {opcoesGenero.map((opcao, index) => (
              <option key={index} value={opcao}>{opcao}</option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label>Telefone:</label>
          <input value={telefone} onChange={(e) => setTelefone(e.target.value)} required />
        </div>

        <div className="form-group">
          <label>Email:</label>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        </div>

        <div className="form-group">
          <label>Experiência Profissional:</label>
          <textarea rows="3" value={experiencia} onChange={(e) => setExperiencia(e.target.value)} />
        </div>

        <div className="form-group multiple-select-group">
          <div>
            <label>Disciplinas:</label>
            <select multiple size={5} value={disciplinas} onChange={(e) =>
              setDisciplinas(Array.from(e.target.selectedOptions, o => o.value))
            }>
              {opcoesDisciplinas.map((disc, idx) => (
                <option key={idx} value={disc}>{disc}</option>
              ))}
            </select>
          </div>

          <div>
            <label>Classes:</label>
            <select multiple size={6} value={classes} onChange={(e) =>
              setClasses(Array.from(e.target.selectedOptions, o => o.value))
            }>
              {opcoesClasses.map((cls, idx) => (
                <option key={idx} value={cls}>{cls}</option>
              ))}
            </select>
          </div>
        </div>

        <div className="form-buttons">
          <button type="submit" className="botao-submit">Cadastrar Professor</button>
          <button type="button" className="botao-cancelar" onClick={handleReset}>Cancelar</button>
        </div>
      </form>
    </div>
  );
};

export default CadastroProfessor;
